module.exports = __webpack_public_path__ + "static/media/avatar_normal.4489aaf6.png";